<template>
  <v-list dense dark>
    <template v-for="(item, index) in menu">
      <v-list-tile :title="item.label" :key="item.label" :to="item.url">
        <v-list-tile-avatar>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.label }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon small>mdi-chevron-right</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <template v-for="sub in item.sub" v-if="item.sub && item.sub.length && $route.path.indexOf(item.url) > -1">
        <v-list-tile :title="sub.url" :to="`${item.url}/${sub.url}`" :key="sub.url">
          <v-list-tile-avatar>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>/{{ sub.url }}</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon small>mdi-chevron-right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </template>
      <v-divider :key="index" />
    </template>
  </v-list>
</template>
<script>
import menu from '../helpers/menu'

export default {
  name: 'Navigation',
  data () {
    return {
      menu
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/navigation.vue